__turbopack_context__.v({
  "accentTreatment": "Heading-module-scss-module__z_h7Ha__accentTreatment",
  "alignCenter": "Heading-module-scss-module__z_h7Ha__alignCenter",
  "alignLeft": "Heading-module-scss-module__z_h7Ha__alignLeft",
  "alignRight": "Heading-module-scss-module__z_h7Ha__alignRight",
  "formatHeadingBox": "Heading-module-scss-module__z_h7Ha__formatHeadingBox",
  "heading": "Heading-module-scss-module__z_h7Ha__heading",
  "headingDisplay": "Heading-module-scss-module__z_h7Ha__headingDisplay",
  "headingH1": "Heading-module-scss-module__z_h7Ha__headingH1",
  "headingH2": "Heading-module-scss-module__z_h7Ha__headingH2",
  "headingH3": "Heading-module-scss-module__z_h7Ha__headingH3",
  "headingH4": "Heading-module-scss-module__z_h7Ha__headingH4",
  "headingH5": "Heading-module-scss-module__z_h7Ha__headingH5",
  "headingH6": "Heading-module-scss-module__z_h7Ha__headingH6",
  "heroSliderMobile": "Heading-module-scss-module__z_h7Ha__heroSliderMobile",
  "highlight": "Heading-module-scss-module__z_h7Ha__highlight",
  "title": "Heading-module-scss-module__z_h7Ha__title",
  "uppercase": "Heading-module-scss-module__z_h7Ha__uppercase",
  "variation140Years": "Heading-module-scss-module__z_h7Ha__variation140Years",
  "variationModerat": "Heading-module-scss-module__z_h7Ha__variationModerat",
  "withBottomPadding": "Heading-module-scss-module__z_h7Ha__withBottomPadding",
});
